export function toPxByRem(px: number) {
    const rem = Math.max(window.innerWidth, 1200) / 100
    return (px * rem) / 12
}
